import React from "react";
import { useNavigate } from "react-router-dom";
import { getTerm } from "$stores/dictionary";

const STATUS_COLORS = {
    Active: "badge-success",
    Complete: "badge-primary",
    Archived: "badge-secondary",
};

// data: array of InitiativeEntity (active initiatives owned or shared with user)
const InitiativeListCard = ({ data, title }) => {
    const navigate = useNavigate();
    const initiatives = Array.isArray(data) ? data : [];

    return (
        <div className="initiative-list-card">
            {title && (
                <header className="initiative-list-card__header">
                    <h4>{title}</h4>
                </header>
            )}
            {initiatives.length === 0 ? (
                <p className="initiative-list-card__empty">No active {getTerm("initiatives").toLowerCase()}.</p>
            ) : (
                <ul className="initiative-list-card__list">
                    {initiatives.map((init) => (
                        <li
                            key={init.id}
                            className="initiative-list-card__row"
                            role="button"
                            tabIndex={0}
                            onClick={() => navigate(`/initiatives/${init.id}`)}
                            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && navigate(`/initiatives/${init.id}`)}
                        >
                            <div className="initiative-list-card__name">{init.name}</div>
                            <div className="initiative-list-card__meta">
                                {init.overdueCount > 0 ? (
                                    <span className="initiative-list-card__overdue">
                                        ⚠ {init.overdueCount} overdue
                                    </span>
                                ) : (
                                    <span className={`badge ${STATUS_COLORS[init.status] || "badge-secondary"}`}>
                                        {init.status}
                                    </span>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default InitiativeListCard;
